export interface ApiErrorShape {
  status: number;
  code: string;
  message: string;
  requestId?: string;
}

export class ApiError extends Error implements ApiErrorShape {
  status: number;
  code: string;
  requestId?: string;

  constructor({ status, code, message, requestId }: ApiErrorShape) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.requestId = requestId;
  }
}
